const filterDuplicates = <T>(array: T[], key: keyof T) => {
  const seenValues: T[] = [];
  array.forEach((item) => {
    if (!seenValues.find((value) => value[key] === item[key])) {
      seenValues.push(item);
    }
  });
  return seenValues;
};

export default filterDuplicates;
